import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../utils/adminApi";
import "./Brand.css";
import { Helmet } from "react-helmet-async"; // ✅ SEO ONLY ADD

import appleLogo from "../assets/apple1.svg";
import googleLogo from "../assets/google-pixel-1.svg";
import motorolaLogo from "../assets/motorola.svg";
import oneplusLogo from "../assets/oneplus-2.svg";
import oppoLogo from "../assets/oppo.svg";
import realmeLogo from "../assets/realme-logo (1).svg";
import vivoLogo from "../assets/vivo.svg";
import xiaomiLogo from "../assets/xiaomi-1.svg";

const brandLogos = {
  apple: appleLogo,
  "google pixel": googleLogo,
  google: googleLogo,
  pixel: googleLogo,
  motorola: motorolaLogo,
  oneplus: oneplusLogo,
  "one plus": oneplusLogo,
  oppo: oppoLogo,
  realme: realmeLogo,
  vivo: vivoLogo,
  xiaomi: xiaomiLogo,
  mi: xiaomiLogo,
  redmi: xiaomiLogo,
};

const buildFallbackLogo = (name = "") => {
  const letter = (name.trim()[0] || "B").toUpperCase();
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'>
    <rect width='140' height='140' rx='28' fill='#0f172a'/>
    <text x='70' y='90' text-anchor='middle'
      font-size='64' font-family='Arial' fill='#ffffff'>
      ${letter}
    </text>
  </svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

const getMappedLogo = (brandName = "") =>
  brandLogos[brandName.trim().toLowerCase()] || null;

const getImageSrc = (value = "") => {
  const src = String(value || "").trim();
  if (!src) return "";
  if (src.startsWith("data:") || src.startsWith("http")) return src;
  return `${API_BASE_URL}/${src.replace(/^\/+/, "")}`;
};

const toSlug = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
const BRAND_SEO = {

  apple: {
    title: "Apple Mobile Repair in Bangalore | iPhone Service",
    description: "Get trusted Apple mobile repair in Bangalore with expert iPhone screen replacement, battery repair, charging port fixing, and doorstep support by Servizy.",
    keywords: "Apple mobile repair Bangalore, iPhone repair Bangalore, Apple service center, iPhone screen replacement",
    canonical: "https://servizy.co.in/apple-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  google: {
    title: "Google Mobile Repair in Bangalore | Pixel Repair",
    description: "Professional Google mobile repair in Bangalore for Pixel screen replacement, battery repair, software issues, and expert doorstep service.",
    keywords: "Google mobile repair Bangalore, Pixel repair Bangalore, Google phone service, smartphone repair",
    canonical: "https://servizy.co.in/google-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  motorola: {
    title: "Motorola Mobile Repair in Bangalore | Servizy",
    description: "Reliable Motorola mobile repair in Bangalore with expert repair solutions for display damage, battery replacement, and charging issues.",
    keywords: "Motorola mobile repair Bangalore, Moto phone repair, mobile repair service, smartphone repair",
    canonical: "https://servizy.co.in/motorola-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  nokia: {
    title: "Nokia Mobile Repair in Bangalore | Phone Repair",
    description: "Get affordable Nokia mobile repair in Bangalore with expert technicians for screen repair, battery replacement, and software troubleshooting.",
    keywords: "Nokia mobile repair Bangalore, Nokia phone repair, smartphone service, mobile fixing",
    canonical: "https://servizy.co.in/nokia-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  nothing: {
    title: "Nothing Mobile Repair in Bangalore | Servizy",
    description: "Trusted Nothing mobile repair in Bangalore for display replacement, battery issues, charging problems, and software support.",
    keywords: "Nothing mobile repair Bangalore, Nothing phone repair, smartphone repair service, mobile service",
    canonical: "https://servizy.co.in/nothing-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  oneplus: {
    title: "OnePlus Mobile Repair in Bangalore | Doorstep Service",
    description: "Professional OnePlus mobile repair in Bangalore with quick repair support for screen damage, battery replacement, and software issues.",
    keywords: "OnePlus mobile repair Bangalore, OnePlus phone repair, smartphone repair Bangalore, mobile fixing",
    canonical: "https://servizy.co.in/oneplus-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  oppo: {
    title: "Oppo Mobile Repair in Bangalore | Phone Service",
    description: "Servizy offers reliable Oppo mobile repair in Bangalore with affordable repair services for all Oppo smartphone models.",
    keywords: "Oppo mobile repair Bangalore, Oppo phone repair, mobile service Bangalore, smartphone repair",
    canonical: "https://servizy.co.in/oppo-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  poco: {
    title: "Poco Mobile Repair in Bangalore | Expert Repair",
    description: "Get trusted Poco mobile repair in Bangalore with expert repair services for display replacement, battery repair, and charging issues.",
    keywords: "Poco mobile repair Bangalore, Poco phone repair, smartphone service, mobile repair center",
    canonical: "https://servizy.co.in/poco-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  realme: {
    title: "Realme Mobile Repair in Bangalore | Servizy",
    description: "Affordable Realme mobile repair in Bangalore for screen replacement, charging port repair, battery replacement, and software support.",
    keywords: "Realme mobile repair Bangalore, Realme phone repair, smartphone repair service, mobile fixing",
    canonical: "https://servizy.co.in/realme-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  redmi: {
    title: "Redmi Mobile Repair in Bangalore | Phone Repair",
    description: "Professional Redmi mobile repair in Bangalore with expert technicians for screen repair, battery replacement, and software troubleshooting.",
    keywords: "Redmi mobile repair Bangalore, Redmi phone repair, Xiaomi repair Bangalore, smartphone service",
    canonical: "https://servizy.co.in/redmi-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  samsung: {
    title: "Samsung Mobile Repair in Bangalore | Servizy",
    description: "Trusted Samsung mobile repair in Bangalore with fast repair solutions for display damage, battery issues, and charging problems.",
    keywords: "Samsung mobile repair Bangalore, Samsung phone repair, smartphone repair Bangalore, mobile service center",
    canonical: "https://servizy.co.in/samsung-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  vivo: {
    title: "Vivo Mobile Repair in Bangalore | Phone Service",
    description: "Professional Vivo mobile repair in Bangalore for screen replacement, battery issues, charging repair, and software support.",
    keywords: "Vivo mobile repair Bangalore, Vivo phone repair, smartphone repair service, mobile fixing",
    canonical: "https://servizy.co.in/vivo-mobile-repair-in-bangalore",
    robots: "index, follow"
  },

  xiaomi: {
    title: "Xiaomi Mobile Repair in Bangalore | Expert Service",
    description: "Reliable Xiaomi mobile repair in Bangalore with doorstep support for screen replacement, battery repair, and software issues.",
    keywords: "Xiaomi mobile repair Bangalore, Xiaomi phone repair, smartphone repair service, mobile fixing",
    canonical: "https://servizy.co.in/xiaomi-mobile-repair-in-bangalore",
    robots: "index, follow"
  }

};
const Brands = () => {
  const navigate = useNavigate();
  const [brands, setBrands] = useState(null);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/brands`);

        // 🔥 Sort brands A → Z here
        const sortedBrands = (Array.isArray(res.data) ? res.data : [])
          .sort((a, b) =>
            a.name.localeCompare(b.name, undefined, {
              sensitivity: "base",
            })
          );

        setBrands(sortedBrands);
      } catch (error) {
        console.error("Error fetching brands:", error);
        setBrands([]);
      }
    };

    fetchBrands();
  }, []);

  return (
      <>

<Helmet>
  {/* BASIC SEO */}
  <title>
    Mobile Brands We Repair in Bangalore | Servizy
  </title>

  <meta
    name="description"
    content="Servizy repairs all major mobile brands in Bangalore including Apple, Samsung, OnePlus, Xiaomi, Oppo, Vivo, Realme, and Motorola."
  />

  <meta
    name="keywords"
    content="mobile repair Bangalore, Apple repair, Samsung repair, OnePlus repair"
  />

  <meta
    name="robots"
    content="index, follow"
  />

  <meta
    name="author"
    content="Servizy"
  />

  <meta
    name="publisher"
    content="Servizy"
  />

  <meta
    property="article:publisher"
    content="https://servizy.co.in/"
  />

  {/* CANONICAL */}
  <link
    rel="canonical"
    href="https://servizy.co.in/brands"
  />

  {/* OPEN GRAPH */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Mobile Brands We Repair in Bangalore | Servizy"
  />

  <meta
    property="og:description"
    content="Servizy repairs all major smartphone brands in Bangalore."
  />

  <meta
    property="og:url"
    content="https://servizy.co.in/brands"
  />

  <meta
    property="og:image"
    content="https://servizy.co.in/s.png"
  />

  <meta
    property="og:site_name"
    content="Servizy"
  />

  {/* TWITTER */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Mobile Brands We Repair in Bangalore | Servizy"
  />

  <meta
    name="twitter:description"
    content="Servizy repairs all major smartphone brands in Bangalore."
  />

  <meta
    name="twitter:image"
    content="https://servizy.co.in/s.png"
  />
</Helmet>
  <div className="brand-page-wrapper">
    <h1>
      Select your <span>Brand</span>
    </h1>

      {brands && (
        <div className="brand-bento-grid">
          {brands.length === 0 && (
            <p className="no-results">
              {/* No brands found. Please add brands from admin panel. */}
            </p>
          )}

          {brands.map((brand, index) => (
            <div
              key={brand._id}
              className="brand-card-premium"
              style={{ "--index": index }}
              onClick={() =>
                navigate(`/${toSlug(brand.name)}-mobile-repair-in-bangalore`)
              }
            >
              <div className="card-content">
                <div className="brand-visual">
                  <img
                    src={
                      brand.logo
                        ? getImageSrc(brand.logo)
                        : getMappedLogo(brand.name) ||
                          buildFallbackLogo(brand.name)
                    }
                    alt={brand.name}
                  />
                </div>

                <div className="brand-details">
                  <h3>{brand.name}</h3>
                  <p>Device Collection</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  
      </>
  );
};

export default Brands;
